import * as React from 'react';
import { AuthLayout } from './AuthLayout';
import { MyLoginForm } from './MyLoginForm';

/**
 * A component that renders a page for resetting the current user password through Supabase.
 * @param props
 * @param props.children The content of the page. If not set, it will render a ForgotPasswordForm.
 *
 * @example
 * import { ForgotPasswordPage } from 'ra-supabase-ui-materialui';
 * import { Admin, CustomRoutes } from 'react-admin';
 *
 * const App = () => (
 *    <Admin dataProvider={dataProvider}>
 *      <CustomRoutes>
 *       <Route path={ForgotPasswordPage.path} element={<ForgotPasswordPage />} />
 *     </CustomRoutes>
 *      ...
 *  </Admin>
 * );
 */
export const MyLoginPage = (props) => {
    const { children = <MyLoginForm /> } = props;

    return <AuthLayout>{children}</AuthLayout>;
};

MyLoginPage.path = '/login';